export const engagementDefaultCommonFilters: Record<string, { defaultExpression: string }> = {
  smart_pixel_lookback_period_filter: { defaultExpression: '7 days' },
  smart_pixel_match_type_filter: { defaultExpression: '' },
  smart_pixel_collection_filter: { defaultExpression: '' },
};
